var exports = {
  "kL": "xe533113f--bc8249--container",
  "my": "xe533113f--bc8249--avatar",
  "Qs": "xe533113f--bc8249--content",
};

module.exports = exports;
